import * as Yup from 'yup';

export const ResolvableMissionTypeFilesSchema = Yup.object().shape({
  allowedFileCategoryIds: Yup.array()
    .of(Yup.string().required('Catégorie de fichier requise'))
    .optional()
    .nullable()
    .default(undefined),
});
